export default "__VITE_ASSET__596eb032__"